var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
export default {
  name: 'NavItemFlat',
  components: {
    MdmLink: MdmLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  }
};